import { Skeleton } from '@mui/material';
import { Box } from '@mui/system';
import { FC, memo } from 'react';

export const FormsSkeleton: FC = memo(() => {
  return (
    <Box>
      <Skeleton variant="rectangular" height={39} />
      <Box sx={{ paddingLeft: '5px', paddingTop: '5px' }}>
        <Skeleton height={70} variant="rectangular" />
        <Box sx={{ height: 5 }} />
        <Skeleton height={70} variant="rectangular" />
      </Box>
    </Box>
  );
});
